import { CartViewResponse } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const setShippingCostBase =
    ({ client }: Pick<JoggApiOption, "client">) =>
    async <S extends CartViewResponse>(cartId: string, shippingMethodId: string, version: number): Promise<S> => {
        const request = (version: number) =>
            client.execute({
                uri: `/ctp/carts/${cartId}`,
                method: "POST",
                body: {
                    version,
                    actions: [
                        {
                            action: "setShippingMethod",
                            shippingMethod: { id: shippingMethodId, typeId: "shipping-method" },
                        },
                    ],
                },
            })
        return handleCartError(request, version, 5)
    }
